/*** IMPORTS FROM imports-loader ***/
var define = false;

import Menu from './modules/Menu.js';
import {Header} from './modules/Header.js';
import RetinaChanges from './modules/RetinaChanges.js';
import Popups from './modules/Popups.js';
import ChangeImg from './modules/ChangeImg';


window.$ = window.jQuery = window.jquery = require('jquery');

require('bootstrap/dist/js/bootstrap');
//require('./vendors.js');

// vue components
import HeaderVue from './vue/Header';
import CallBack from './vue/CallBack';

import CookieConsent from './modules/CookieConsent.js';

// bugfix: предотвращает установку скролла в рандомное место
if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
}

$(document).ready(function () {

    /**
     * ChangeImg
     */
    (new ChangeImg()).init();

    /**
     * Header/Top menu
     */
    Header.init();
    (new Menu()).init();

    /**
     * NEW Header/Top menu
     */
    (new HeaderVue("#HeaderVue")).init();

    /**
     * Replace retina images
     */
    (new RetinaChanges('.retina-image')).init();

    // Управление первым блоком с видео
    let homepageBannerElement = document.querySelector('.home-page__banner-wrapper');
    let firstVideoElement = document.getElementById('firstVideo');
    let secondVideoElement = document.getElementById('secondVideo');

    firstVideoElement.addEventListener('canplaythrough',  () => {
        homepageBannerElement.style.display = 'flex';

        if (firstVideoElement.readyState === 4) {
            if (!firstVideoElement.muted){
                firstVideoElement.muted = true;
                firstVideoElement.play();
            } else {
                firstVideoElement.play();
            }
        } else {
            firstVideoElement.poster = '/dist/img/home-page/background-banner.webp'
        }
    });

    firstVideoElement.addEventListener('ended',  () => {
        firstVideoElement.classList.add('video-hidden');
        secondVideoElement.classList.remove('video-hidden');
    });

    /**
     * CallBck Pop-up
     */

    (new CallBack("#CallBackVue")).init();

    (new Popups()).init();

    /**
     * Cookie consent
     */
    (new CookieConsent()).init();

    function addScrollEventForTagManager(){
        let scrolled = window.scrollY > 0;
        if (scrolled){
            window.dataLayer.push({'event': 'scrollTrigger'});
        }
    }

    window.addEventListener('scroll', addScrollEventForTagManager)

});


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Set csrf token to jquery ajax
 */
$.ajaxSetup({

    cache: false,

    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/homepage.js